import { CreateTile, Icon, Tile } from '@thro-types/users';

import { TFunction } from 'i18next';
import { pick } from 'lodash';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

import { TileType } from '../../containers/Dashboard/HomePage';

export const tileValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup
    .object()
    .shape({
      title_de: yup
        .string()
        .required(t(translations.validation.required()))
        .label(t(translations.pages.home.cardDrawer.title())),
      title_en: yup
        .string()
        .label(t(translations.pages.home.cardDrawer.titleEN()))
        .when('type', {
          is: 'CUSTOM',
          then: yup.string().nullable(),
          otherwise: yup.string().required(t(translations.validation.required()))
        }),
      shortText_de: yup
        .string()
        .required(t(translations.validation.required()))
        .label(t(translations.pages.home.cardDrawer.shortText())),
      shortText_en: yup
        .string()
        .label(t(translations.pages.home.cardDrawer.shortTextEN()))
        .when('type', {
          is: 'CUSTOM',
          then: yup.string().nullable(),
          otherwise: yup.string().required(t(translations.validation.required()))
        }),
      icon: yup.mixed(),
      iconToUpload: yup.mixed(),
      link: yup
        .string()
        .required(t(translations.validation.required()))
        .label(t(translations.pages.home.cardDrawer.link())),
      visibilityGroups: yup.array().when('type', {
        is: 'CUSTOM',
        then: yup.array(),
        otherwise: yup
          .array()
          .of(yup.number().required())
          .min(1, 'At least one VisibilityGroup has to be selected')
          .required()
      })
    })
    .test(
      'iconOrIconToUpload',
      'Either "icon" or "iconToUpload" is required',
      function (value: { icon: Icon; iconToUpload: Blob }) {
        // Access the fields from the context of the schema
        const { icon, iconToUpload } = value;
        // Check that at least one is not undefined or null
        if (
          (icon.path !== undefined && icon.path !== null) ||
          (iconToUpload !== undefined && iconToUpload !== null)
        ) {
          return true;
        }
        return this.createError({
          path: 'icon', // or 'icon', you can choose where to show the error
          message: 'Either "icon" or "iconToUpload" is required.'
        });
      }
    );

export const initialCardValues = (
  type: TileType,
  initialTile?: Tile | undefined
): Tile | CreateTile => {
  return initialTile
    ? {
        ...pick(initialTile, [
          'id',
          'title_de',
          'title_en',
          'shortText_de',
          'shortText_en',
          'icon',
          'isExternal',
          'link',
          'visibilityGroups',
          'type',
          'styleType'
        ])
      }
    : {
        id: undefined,
        title_de: '',
        title_en: '',
        shortText_de: '',
        shortText_en: '',
        icon: { id: 0, path: '', isRounded: false, isDefault: false },
        isExternal: false,
        link: '',
        visibilityGroups: [],
        type: type,
        styleType: undefined
      };
};
